import React, { useState, useEffect } from 'react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md' : 'bg-white/95 backdrop-blur-sm shadow-sm'}`} id="navbar">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-20">

                    {/* Logo */}
                    <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo(0, 0)}>
                        <img src="/logo_rd.png" alt="Garaje Pro 360" className="h-10 w-auto" />
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-8">
                        <a href="#inicio" className="text-gray-600 hover:text-brand-600 font-medium transition-colors">Inicio</a>
                        <a href="#servicios" className="text-gray-600 hover:text-brand-600 font-medium transition-colors">Funciones</a>
                        <a href="#nosotros" className="text-gray-600 hover:text-brand-600 font-medium transition-colors">Beneficios</a>
                        <a href="#contacto" className="text-gray-600 hover:text-brand-600 font-medium transition-colors">Contacto</a>
                        <a href="#contacto" className="bg-brand-600 text-white px-6 py-2.5 rounded-full font-medium hover:bg-brand-500 transition-colors shadow-md shadow-brand-500/30">
                            Registrar mi Taller
                        </a>
                    </div>

                    {/* Mobile menu button */}
                    <div className="md:hidden flex items-center">
                        <button className="text-gray-600 hover:text-brand-600 focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                            {isMenuOpen ? (
                                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                                </svg>
                            ) : (
                                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/>
                                </svg>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            <div className={`${isMenuOpen ? 'block' : 'hidden'} md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg`}>
                <div className="px-4 pt-2 pb-6 space-y-1">
                    <a href="#inicio" onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-brand-600 hover:bg-gray-50">Inicio</a>
                    <a href="#servicios" onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-brand-600 hover:bg-gray-50">Funciones</a>
                    <a href="#nosotros" onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-brand-600 hover:bg-gray-50">Beneficios</a>
                    <a href="#contacto" onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-brand-600 hover:bg-gray-50">Contacto</a>
                    <div className="pt-4 px-3">
                        <a href="#contacto" onClick={() => setIsMenuOpen(false)} className="w-full flex justify-center bg-brand-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-brand-500 transition-colors">
                            Registrar mi Taller
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Header;
